/* Fonzie Application
 ========================================================================== */

$(function () {

	/* Global */
	template.media_query();

    /* Application */
    app.icheck();
    app.donations();

    const resourceApp = $('#resourcesApp');
    if( resourceApp.length > 0 ) {
        app.resource_cart();
    }

    /* Template */
    template.mobile_menu();
    template.desktop_subnav();
    template.mobile_subnav();
    template.share_modal();
    template.campaign_progress();
    template.repeater_gallery();
    template.accordion();
    template.panelClass();
    template.archive_filter();
    template.equalContainers();
    template.hero_btn_scroll();
    template.table_info();
    template.resources();

    /* Misc */
    $( window ).load(function() {
        template.desktop_more_menu();
    });

    if($('#site-header_top').length > 0) {
    	template.microsites();
    }

    var map = $('.acf-map');
    if( map.length > 0 ) {
        map.each(function () {
            // create map
            map = app.new_map($(this));

        });
    }

});
